/*!

=========================================================
* Black SalesDashboard React v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { createBrowserHistory } from "history";
import ReactDOM from "react-dom";
import { Redirect, Route, Router, Switch } from "react-router-dom";

import Xero from "components/Products/Xero.js";
import EntraAuthRedirect from "components/MicrosoftSSO/EntraAuthRedirect.js";
import AdminLayout from "layouts/Admin/Admin.js";
import LoginLayout from "layouts/Login/Login.js";

import { msalConfig } from './config/msalConfig';

import "assets/css/nucleo-icons.css";
import "assets/demo/demo.css";
import "assets/scss/black-dashboard-react.scss";
import React from 'react';

const c = React.createElement;
const hist = createBrowserHistory();

// Initialize MSAL instance only if configured
const msalInstance = process.env.REACT_APP_MICROSOFT_CLIENT_ID
  ? new PublicClientApplication(msalConfig)
  : null;

// Wrapper component that conditionally applies MsalProvider
const AuthProviders = ({ children }) => {
  const content = (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_APP_CLIENT_ID}>
      {children}
    </GoogleOAuthProvider>
  );

  if (msalInstance) {
    return <MsalProvider instance={msalInstance}>{content}</MsalProvider>;
  }
  return content;
};

ReactDOM.render(
  <AuthProviders>
    <Router history={hist}>
      <Switch>
        <Route path="/admin" render={props => <AdminLayout {...props} />} />
        <Route path="/login" render={props => <LoginLayout {...props} />} />
        <Route path="/xero/callback"><Xero /></Route>
        <Route path="/entra-auth"><EntraAuthRedirect /></Route>
        <Redirect from="/" to="/admin/sales-dashboard" />
      </Switch>
    </Router>
  </AuthProviders>,
  document.getElementById("root")
);
